// Tabs shown on the surveys page. To add a new tab, add an id here, an entry
// in SURVEYS_HUB_TABS below and its content in SurveysHubContainer.
export const SURVEYS_HUB_TAB_PARAM = "tab";

/* eslint-disable no-unused-vars */
export enum SurveysHubTabId {
  MORE_SURVEYS = "more",
  MY_SURVEYS = "my-surveys",
}
/* eslint-enable no-unused-vars */

export interface SurveysHubTab {
  id: SurveysHubTabId;
  // Full-bleed tabs (e.g. embedded external portals) fill the viewport below
  // the tab bar with no footer and no extra bottom spacing.
  fullBleed: boolean;
}

export const SURVEYS_HUB_TABS: SurveysHubTab[] = [
  { id: SurveysHubTabId.MORE_SURVEYS, fullBleed: true },
  { id: SurveysHubTabId.MY_SURVEYS, fullBleed: false },
];

export const DEFAULT_SURVEYS_HUB_TAB = SurveysHubTabId.MORE_SURVEYS;

const findTab = (tabId: string | null) =>
  SURVEYS_HUB_TABS.find((tab) => tab.id === tabId);

// Resolves the active tab from the URL (?tab=...). Navigations that carry a
// survey sort tab in their state (e.g. coming back from the survey profiler)
// are meant for the survey listing, so they open the My Surveys tab.
export const getSurveysHubTab = (
  search: string,
  state?: unknown,
): SurveysHubTab => {
  const tabFromUrl = findTab(
    new URLSearchParams(search).get(SURVEYS_HUB_TAB_PARAM),
  );
  if (tabFromUrl) return tabFromUrl;

  const hasSortTabState =
    (state as { selectedSortTab?: unknown } | null)?.selectedSortTab !==
    undefined;
  return findTab(
    hasSortTabState ? SurveysHubTabId.MY_SURVEYS : DEFAULT_SURVEYS_HUB_TAB,
  )!;
};
